import styled from "@emotion/styled";
import { Badge } from "../../../shared/Badge";
const getBadgeMinWidth = buttonSize => {
  switch (buttonSize) {
    case "large":
    case "medium":
      return 9;
    case "small":
    case "xsmall":
      return 1;
  }
};
export const getBadgeSize = buttonSize => {
  switch (buttonSize) {
    case "large":
    case "medium":
      return 16;
    case "small":
    case "xsmall":
      return 8;
  }
};
const ButtonSizeToOffset = {
  large: -7,
  medium: -7,
  small: -3.5,
  xsmall: -4
};
const getBadgeOffset = _ref => {
  let {
    buttonSize,
    offset = 0
  } = _ref;
  return ButtonSizeToOffset[buttonSize] - offset;
};
export const ButtonBadge = styled(Badge)`
    top: ${_ref2 => {
  let {
    buttonSize,
    offset
  } = _ref2;
  return getBadgeOffset({
    buttonSize,
    offset: offset?.y ?? 0
  });
}}px;
    right: ${_ref3 => {
  let {
    buttonSize,
    offset
  } = _ref3;
  return getBadgeOffset({
    buttonSize,
    offset: offset?.x ?? 0
  });
}}px;
    // these next two numbers differ from figma because of the .5px padding figma gives to text
    border-radius: 16px;
    padding: 0px 3.5px;
    min-width: ${_ref4 => {
  let {
    buttonSize
  } = _ref4;
  return getBadgeMinWidth(buttonSize);
}}px;
`;
//# sourceMappingURL=ButtonBadge.js.map